import { Injectable } from '@angular/core';
import { Subject } from '../common';
// Angular imports


@Injectable({
  providedIn: 'root'
})
export class SideBarService {
  toggler: Subject<boolean>;
  currentPath: Subject<string>;
  constructor() { 
    this.toggler = new Subject();
    this.currentPath = new Subject();
  }
}
